// extracted by mini-css-extract-plugin
module.exports = {"dpu-detail-M":"M_dpu-detail-M__o6pt6"};